module.exports = __webpack_public_path__ + "static/media/medium-bus.adb49e31.svg";